import { useStore } from 'vuex'
import SourceGroupCard from 'components/SourceGroupCard/SourceGroupCard.vue'
import SourceExternalLinks from 'components/SourceExternalLinks/SourceExternalLinks.vue'
import SourceReferences from 'components/SourceReferences/SourceReferences.vue'

export default {
    name: "SourceOverlay",
    components: {
        SourceGroupCard,
        SourceExternalLinks,
        SourceReferences
    },
    props: {
        labels: {
            type: Array,
            required: false
        },
        source: {
            type: Object,
            required: false
        }
    },
    setup() {
        const store = useStore()
        
        const props = store.state.main.page_overlay_content_data ?? {}
        props.labels.forEach((labelCollection) => {
            store.commit('labels/set_labelCollection', labelCollection)
        })

        const getLabel = (labelKey) => store.getters['labels/getLabel']({
            labelCollection: 'SourceOverlay',
            labelKey
        })

        return {
            getLabel,
            source: props.source,
        }
    }
}